import classNames from 'classnames'
import { t } from 'i18next'
import { useContext } from 'react'
import ParentFormDataContext from '../../../contexts/ParentFormDataContext'
export interface IParentConfirmation {
    className?: string
}

const ParentConfirmation: React.FC<IParentConfirmation> = ({ className }) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    return (
        <div className='flex justify-center pt-7'>
            <div className="h-auto flex flex-col items-center justify-center bg-white lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md py-6">
                <h1 className="lg:text-xl text-lg font-bold text-center">
                    {t('parentInfo')}
                </h1>
                <div className={classNames(className, 'md:grid md:grid-cols-2 space-y-4 md:space-x-5 flex flex-col justify-center lg:w-[20rem] md:w-[15rem] w-[8rem] ')}>
                    <div className='pt-4 md:pl-5 lg:w-[8rem] md:w-[6rem]'>
                        <p className="font-bold">{t('name')}</p>
                        <p>
                            {parentFormData.FirstName}{' '}
                            {parentFormData.LastName}
                        </p>
                    </div>
                    <div>
                        <p className="font-bold">{t('phoneNum')}</p>
                        <p>{parentFormData.PhoneNumber}</p>
                    </div>
                    <div>
                        <p className="font-bold">{t('address')}</p>
                        <p>
                            {parentFormData.Address}
                            <br />
                            {`${parentFormData.City}, ${parentFormData.Province.id}`}
                            <br />
                            {parentFormData.PostalCode}
                        </p>
                    </div>
                    <div >
                        <p className="font-bold">{t('emailAddress')}</p>
                        <p>{parentFormData.Email}</p>
                    </div>
                </div>
                <div className='lg:w-[17.5rem] md:w-[12.5rem] w-[7.8rem] pt-4'>
                    <p className="font-bold">{t('policyStartDate')}</p>
                    <p>
                        {parentFormData.StartDate
                            ? parentFormData.StartDate.getMonth() + 1
                            : 'xx'}
                        /
                        {parentFormData.StartDate
                            ? parentFormData.StartDate.getDate()
                            : 'xx'}
                        /
                        {parentFormData.StartDate
                            ? parentFormData.StartDate.getFullYear()
                            : 'xxxx'}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ParentConfirmation
